// extracted by mini-css-extract-plugin
export default {"products":"_C-z","card":"aD-z","oosMessaging":"bD-z"};